<template>
  <span>{{ formattedValue }}</span>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'showValueRoundingDigit',
  computed: {
    ...mapGetters({
      $_tendersSettings: 'getTendersSettings',
    }),
    formattedValue() {
      const max = this.maximumFractionDigits ?? this.$_tendersSettings.priceRoundingDigit
      return this.$n(this.value, {
        minimumFractionDigits: this.minimumFractionDigits,
        // max < min (налаштування 0/1) або не число дало б RangeError в Intl — тоді не менше мінімуму
        maximumFractionDigits: max == null ? max : Math.max(Number(max) || 0, this.minimumFractionDigits),
        useGrouping: this.useGrouping
      })
    }
  },
  props: {
    value: [String, Number],
    minimumFractionDigits: {
      type: Number,
      default: 2
    },
    maximumFractionDigits: {
      type: Number,
    },
    useGrouping: {
      type: Boolean,
      default: true
    }
  },
}
</script>
